// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rf-c";
export var backButton = "_rf-4";
export var backIcon = "_rf-5";
export var chevronShortcut = "_rf-6";
export var container = "_rf-1";
export var editor = "_rf-8";
export var editorWrapper = "_rf-7";
export var prefix = "_rf-2";
export var searchIcon = "_rf-3";
export var suffix = "_rf-9";
export var suffixContent = "_rf-a";
export var suffixText = "_rf-b";
export var wrapper = "_rf-0";